<template>
  <div class="content">
    <el-form :model="propsParams" ref="ruleForm" :rules="rules" label-width="170px">
      <el-card shadow="never" style="width: 50%">
        <el-form-item label="客户名称：" prop="customerName">
          <el-input v-model="propsParams.customerName" maxlength="50" placeholder="客户名称"></el-input>
        </el-form-item>
        <el-form-item label="业务员：" prop="salesman">
          <el-input v-model="propsParams.salesman" maxlength="50" placeholder="业务员"></el-input>
        </el-form-item>
        <el-form-item label="公司地址：" prop="companyAddress">
          <el-input v-model="propsParams.companyAddress" maxlength="50" placeholder="公司地址"></el-input>
        </el-form-item>
        <el-form-item label="使用设备：" prop="useDevice">
          <el-input v-model="propsParams.useDevice" placeholder="使用设备" maxlength="255"></el-input>
        </el-form-item>
        <el-form-item label="使用场景：" prop="useDevice">
          <el-input v-model="propsParams.useScreen" placeholder="使用场景" maxlength="255"></el-input>
        </el-form-item>
        <el-form-item label="联系人：" prop="linkman">
          <el-input v-model="propsParams.linkman" maxlength="50" placeholder="联系人"></el-input>
        </el-form-item>
        <el-form-item label="联系人电话：" prop="linkmanPhone">
          <el-input v-model="propsParams.linkmanPhone" maxlength="15" placeholder="联系人电话"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input v-model="propsParams.remark" maxlength="255" placeholder="备注"></el-input>
        </el-form-item>
      </el-card>
      <el-card shadow="never" style="width: 50%">
        <div slot="header" class="clearfix">
          <span style="font-size: 20px; color: #181818; font-weight: 600">图片资料</span>
        </div>
        <el-row>
          <el-col :span="12">
            <el-form-item label="使用设备的图片" prop="useDevicePicture">
              <el-upload class="avatar-uploader" :action="url" accept=".jpg,.png" :show-file-list="false" :on-success="handleIdCardHeadImgSuccess" :before-upload="beforeAvatarUpload">
                <img v-if="propsParams.useDevicePicture" :src="propsParams.useDevicePicture" class="avatar"/>
                <i v-if="!propsParams.useDevicePicture" class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="营业执照" prop="businessLicensePicture">
              <el-upload class="avatar-uploader" :action="url" accept=".jpg,.png" :show-file-list="false" :on-success="handleIdCardBackImgSuccess" :before-upload="beforeAvatarUpload">
                <img v-if="propsParams.businessLicensePicture" :src="propsParams.businessLicensePicture" class="avatar"/>
                <i v-if="!propsParams.businessLicensePicture" class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
      </el-card>

      <div class="footer">
        <el-button type="primary" @click="saveForm">保存</el-button>
        <el-button type="primary" @click="submitAndFlow">提交</el-button>
      </div>
    </el-form>
  </div>
</template>
<script>
import { insertCustomerInfo,submitFlowCustomer } from "@/api/api.js";
export default {
  name: "customerInformationAdd",
  data() {
    var checkUseDevicePicture = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("使用设备的图片不能为空"));
      } else {
        callback();
      }
    };
    var checkBusinessLicensePicture = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("营业执照不能为空"));
      } else {
        callback();
      }
    };
    return {
      url: "cms/file/upload/customerInformation",
      propsParams: {
        id: undefined,
        useDevicePicture: undefined,
        businessLicensePicture: undefined,
        customerName: undefined,
        companyAddress: undefined,
        salesman: undefined,
        useDevice: undefined,
        useScreen: undefined,
        useDevicePicture: undefined,
        linkman: undefined,
        linkmanPhone: undefined,
        businessLicensePicture: undefined,
        remark: undefined,
      },
      rules: {
        customerName: [
          { required: true, message: "客户名称不能为空", trigger: "blur" },
        ],
        companyAddress: [
          { required: true, message: "公司地址不能为空", trigger: "blur" },
        ],
        salesman: [
          { required: true, message: "业务员不能为空", trigger: "blur" },
        ],
        useDevice: [
          {required: true, message: "使用设备不能为空", trigger: "blur",},
        ],
        useScreen: [
          {required: true, message: "使用场景不能为空", trigger: "blur",},
        ],
        linkmanPhone: [
          {required: true, pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/, message: "请输入正确的手机号码", trigger: "blur",},
        ],
        linkman: [
          {required: true, message: "联系人不能为空", trigger: "blur",},
        ],
        useDevicePicture: [
                { required: true, validator: checkUseDevicePicture, trigger: "blur" },
        ],
        businessLicensePicture: [
          {required: true, validator: checkBusinessLicensePicture, trigger: "blur",},
        ],
      },
      // 倒计时的显示
      showCountDown: true,
      count: "",
      timer: null,
    };
  },
  computed: {
    adminShow() {
      return this.$store.getters.user.userType == "1";
    },
    customerKey(){
      return 'customerKey-' + this.$store.getters.user.userId;
    }
  },
  methods: {
    /*saveFormData() {
      try {
        localStorage.setItem(this.customerKey, JSON.stringify(this.propsParams));
      } catch (error) {
        console.error('保存表单数据到 localStorage 时出错:', error);
      }
    },
    loadFormData() {
      try {
        const storedData = localStorage.getItem(this.customerKey);
        if (storedData) {
          this.propsParams = JSON.parse(storedData);
        }
      } catch (error) {
        console.error('从 localStorage 加载表单数据时出错:', error);
      }
    },*/
    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 2MB!");
      }
      return isLt2M;
    },
    //上传使用设备的图片
    handleIdCardHeadImgSuccess(res, file) {
      if (res.code == 200) {
        this.propsParams.useDevicePicture = "/cms/" + res.data.url;
        //this.saveFormData();
      }
    },
    // 上传公司营业执照图片
    handleIdCardBackImgSuccess(res, file) {
      if (res.code == 200) {
        this.propsParams.businessLicensePicture = "/cms/" + res.data.url;
        //this.saveFormData();
      }
    },
    // 保存客户信息
    saveForm() {
      if (!this.propsParams.customerName) {
        this.$message.error("客户名称不能为空");
        return
      }
      let params = {
        ...this.propsParams,
      };
      insertCustomerInfo(params).then((res) => {
        if (res.data.code == 200) {
          this.$notify({
            title: "成功",
            message: "新增成功",
            type: "success",
            duration: 1500,
          });
          //localStorage.removeItem(this.customerKey);//清空客户信息缓存
          this.$store.dispatch('tagsView/delView', this.$route);
          this.$router.push("/shipment/customerInformation");
        } else {
          this.$message.error(res.data.message);
        }
      });
    },

    isValidMobileNumber(phoneNumber) {
      // 定义正则表达式
      const regex = /^1[3-9]\d{9}$/;
      // 使用正则表达式测试手机号
      return regex.test(phoneNumber);
    },

    isValidLineNumber(landlineNumber) {
      const regex = /^(\d{3,4})-?(\d{7,9})$/;
      return regex.test(landlineNumber);
    },

    submitAndFlow() {
      /*if (!this.propsParams.customerName) {
        this.$message.error("客户名称不能为空");
        return
      }
      if (!this.propsParams.companyAddress) {
        this.$message.error("公司地址不能为空");
        return
      }
      if (!this.propsParams.useDevice) {
        this.$message.error("使用设备不能为空");
        return
      }
      if (!this.propsParams.useScreen) {
        this.$message.error("使用场景不能为空");
        return
      }
      if (!this.propsParams.linkman) {
        this.$message.error("联系人不能为空");
        return
      }
      if (!this.propsParams.useDevice) {
        this.$message.error("使用设备不能为空");
        return
      }
      if (!this.isValidMobileNumber(this.propsParams.linkmanPhone)) {
        this.$message.error("请输入正确的手机号码");
        return
      }
      if (!this.propsParams.useDevicePicture) {
        this.$message.error("使用设备的图片不能为空");
        return
      }
      if (!this.propsParams.businessLicensePicture) {
        this.$message.error("营业执照不能为空");
        return
      }*/
      let params = {
        ...this.propsParams,
      };
      this.$refs["ruleForm"].validate((valid) => {
          if (valid) {
            submitFlowCustomer(params).then((res) => {
              if (res.data.code == 200) {
                this.$notify({
                  title: "成功",
                  message: "提交成功",
                  type: "success",
                  duration: 1500,
                });
                //localStorage.removeItem(this.customerKey);//清空客户信息缓存
                this.$store.dispatch('tagsView/delView', this.$route);
                this.$router.push("/shipment/customerInformation");
              } else {
                this.$message.error(res.data.message);
              }
            });
          }
      });
    },
  },
  mounted() {
    //this.loadFormData();
  },
  created() {},
};
</script>
<style scoped lang="less">
.content {
  padding: 50px;
  .footer{
    width: 50%;
    text-align: center;
    padding: 10px 10px
  }
}
.p_class {
  font-size: 20px;
  color: red;
  margin-bottom: 50px;
}

.avatar-uploader {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 138px;
  height: 138px;
}
.avatar-uploader:hover {
  border-color: #409eff;
}
.svg-avatar-uploader-icon {
  font-size: 28px;
  width: 60px;
  height: 60px;
  line-height: 18px;
  text-align: center;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 138px;
  height: 138px;
  line-height: 138px;
  text-align: center;
}
.avatar {
  width: 138px;
  height: 138px;
  display: block;
}
</style>


